var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContacts2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6877 9.66675H45.3127C49.5007 9.66675 52.9232 12.9448 53.1545 17.0752L53.1668 17.5209V40.4792C53.1668 44.6673 49.8886 48.0898 45.7583 48.3211L45.3127 48.3334H12.6877C8.49951 48.3334 5.07698 45.0552 4.84592 40.9249L4.8335 40.4792V17.5209C4.8335 13.3328 8.11158 9.91023 12.242 9.67917L12.6877 9.66675ZM49.5418 22.6515L29.8443 33.0207C29.3914 33.259 28.8627 33.293 28.3883 33.1229L28.156 33.0207L8.4585 22.6539V40.4792C8.4585 42.6982 10.1673 44.518 12.3408 44.6944L12.6877 44.7084H45.3127C47.5316 44.7084 49.3514 42.9996 49.5278 40.826L49.5418 40.4792V22.6515ZM45.3127 13.2917H12.6877C10.4688 13.2917 8.64895 15.0006 8.47251 17.1741L8.4585 17.5209V18.5577L29.0002 29.3686L49.5418 18.5552V17.5209C49.5418 15.302 47.833 13.4822 45.6595 13.3058L45.3127 13.2917Z",
    fill: "#13559F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContacts2);
export default __webpack_public_path__ + "static/media/contacts-2.d610654b54fd3ac9a9d1b276a549ee03.svg";
export { ForwardRef as ReactComponent };